/* @flow weak */
import cx from 'classnames';
import React from 'react';
import TrackedInput from 'components/TrackedInput.jsx';

class MMYYInput extends React.Component {
  static propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.string,
  };

  static contextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  state = {
    value: this.props.value || '',
  }

  handleChange(event) {
    const inputs = event.target.value.split('').filter((char, index) => {
      return !isNaN(parseInt(char, 10)) || (index === 2 && char === '/');
    });

    if (inputs.length === 1) {
      const num = parseInt(inputs[0], 10);
      if (num > 1) {
        inputs.unshift('0');
        inputs.push('/');
      }
    } else if (
      (inputs.length === 2 && this.state.value.length === 1) ||
      (inputs.length > 2 && inputs[2] !== '/')
    ) {
      inputs.splice(2, 0, '/');
    }

    const newValue = inputs.join('');

    this.setState({ value: newValue });

    if (this.props.onChange) {
      this.props.onChange(newValue);
    }
  }

  render() {
    return (
      <TrackedInput
        {...this.props}
        type="text"
        autoComplete="cc-exp"
        maxLength={5}
        placeholder="MM/YY"
        value={this.state.value}
        className={cx('cc-exp', this.props.className)}
        onChange={this.handleChange.bind(this)}
        eventScreenName={this.context.eventScreenName}
        eventElementName="add_date"
      />
    );
  }
}

export default MMYYInput;



// WEBPACK FOOTER //
// ./src/payments/components/MMYYInput.jsx